/* 
    Copyright 2022-06-23 por Cristian Soto Ecomsur Holding S.A ©
    Detalle: Se agrega a EOS mantenedor de estados pedidos POS
*/

import React, { FC, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { StandardPage } from '../../components/_EOS/StandardPage'
import { State } from '../../components/_EOS/State'
import { useApi } from '../../hooks/useApi'
import { OrderStateDto } from './entities/OrderStateDto'
import { get } from './api'

import { EditForm } from './forms/EditForm'

interface Props{

}

export const OrderStateEdit: FC<Props> = () => {
    const { id } = useParams<{id: string }>()
    const { state, callApi } = useApi<OrderStateDto>()

    useEffect(() => {
        callApi(get(id))
    }, [id])

    return (
        <StandardPage pageTitle='Estado Pedido' backAction={true}>
            <State state={state} loadingMessage='Cargando estado pedido'>
                {
                    state.data && 
                        <EditForm orderState={state.data} />
                }
            </State>
        </StandardPage>
    )
}